import misRutas from 'vue-routes-generator'
import Main from './Main'
import Listado from './components/listado/listado'
import Editor from './components/radiacion/radiacion'

export default {
	install: Vue => {
		misRutas.route('/main').child('radiacion', {
			name: 'Radiación',
			component: Main
		})

		misRutas.route('/main').child('radiacion').child('listado', {
			name: 'Listado radiaciones',
			component: Listado
		})

		misRutas.route('/main').child('radiacion').child(':id', {
			name: 'Editor de radiaciones',
			component: Editor
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/radiacion/vue/index.js